export default __webpack_public_path__ + "static/media/B_03_01_bg.fbfaad7c.mp4";